<template>
  <div>
    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-textarea
      label="Description"
      v-model="form.description"
      :validation-errors="validationErrors.description"
    ></form-field-textarea>

    <form-field-input
      label="Affiliate Id"
      v-model="form.affiliate_id"
      :validation-errors="validationErrors.affiliate_id"
      help-text="This can be found in your affiliate dashboard.  Only one Shareable Group can have an Affiliate Id"
    ></form-field-input>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "ShareableGroupFrom",
  props: ["formData"],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        label: "",
        description: "",
        affiliate_id: null,
      },
    };
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
    this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  methods: {
    update() {
      return this.$api.shareableGroups.update(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: "Shareable Group was updated",
            type: "is-success"
          });

          return res;
        });
    },
    create() {
      return this.$api.shareableGroups.create(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: "Shareable Group was created",
            type: "is-success"
          });

          return res;
        });
    },
    delete() {
      return this.$utils.confirm(
        `You are about to completely remove this shareable group.  If the group is being shared with another account, they will no longer see it in their store.<br><br>Anything they installed into the account from this group will still be available in their account.<br><br>This cannot be undone`,
        `Archive ${this.form.label}`
      ).then(() => {
        return this.$api.shareableGroups.delete(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: "Shareable Group was archived",
              type: "is-success"
            });

            return res;
          });
      });
    },
    restore() {
      return this.$api.shareableGroups.restore(this.form.id)
        .then(res => {
          this.$buefy.toast.open({
            message: "Shareable Group was restored",
            type: "is-success"
          });

          return res;
        });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
